import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { OG_CONFIG } from './services/api/config';

Vue.use(Vuex);
import get from 'lodash/get';
import adminConversationsStore from './modules/admin/conversations/store/admin-conversations.store';

export default new Vuex.Store({
  modules: {
    adminConv: adminConversationsStore,
  },
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user: JSON.parse(localStorage.getItem('user')) || {},
    billing_profiles: JSON.parse(localStorage.getItem('billing_profiles')) || [],
    clavedat: localStorage.getItem('clavedat') || '',
    user_business: JSON.parse(localStorage.getItem('user_business')) || [],
    admin: localStorage.getItem('admin') || false,
    admin_original_token: localStorage.getItem('admin_original_token') || false,
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading';
    },
    auth_success(state, data) {
      state.status = 'success';
      state.token = data.token;
      state.user = data.user;
      state.clavedat = data.clavedat;
      state.admin = data.admin;
      state.user_business = data.user_business;
      state.billing_profiles = data.user.openbilling_profiles;
    },
    auth_error(state) {
      state.status = 'error';
    },
    logout(state) {
      state.status = '';
      state.token = '';
      state.user = {};
      state.clavedat = '';
      state.admin = false;
      state.user_business = [];
      state.admin_original_token = false;
      state.billing_profiles = [];
    },
    skip_tour(state) {
      state.user.skip_tour = true;
      localStorage.setItem('user', JSON.stringify(state.user));
    },
    change_clavedat(state, clavedat) {
      state.clavedat = clavedat;
      localStorage.setItem('clavedat', clavedat);
    },
    reactivate_tour(state) {
      state.user.skip_tour = false;
      localStorage.setItem('user', JSON.stringify(state.user));
    },
    set_admin_original_token(state, token) {
      state.admin_original_token = token;
      localStorage.setItem('admin_original_token', 'Bearer ' + token);
    },
    updateCurrentOpenbillingProfile(state, data) {
      const index = state.user.openbilling_profiles.findIndex(
        profile => profile['clavedat'] == state.clavedat,
      );
      Vue.set(state.user.openbilling_profiles, index, data);
      Vue.set(state.billing_profiles, index, data);
      const user = JSON.parse(localStorage.getItem('user'));
      user.openbilling_profiles[index] = data;
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('billing_profiles', JSON.stringify(user.openbilling_profiles));
    },
  },
  actions: {
    skipTour({ commit }) {
      commit('skip_tour');
    },
    changeClavedat({ commit }, clavedat) {
      commit('change_clavedat', clavedat);
    },
    reactivateTour({ commit }) {
      commit('reactivate_tour');
    },
    login({ commit, dispatch }, user) {
      return new Promise((resolve, reject) => {
        let formdata = user;
        formdata.grant_type = 'password';
        formdata.client_id = OG_CONFIG.CLIENT_ID;
        formdata.client_secret = OG_CONFIG.CLIENT_SECRET;

        commit('auth_request');
        axios({
          url: OG_CONFIG.BASE_URL + '/oauth/token',
          data: formdata,
          method: 'POST',
        })
          .then(resp => {
            const access_token = resp.data.access_token;
            const token_type = resp.data.token_type;
            const token = token_type + ' ' + access_token;

            dispatch('loginFromToken', token)
              .then(() => {
                // console.log({loginFromToken: res});
              })
              .finally(() => {
                return resolve(resp);
              });
          })
          .catch(err => {
            commit('auth_error');
            localStorage.removeItem('token');
            reject(err);
          });
      });
    },

    backToAdminLogin({ dispatch }, token) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem('admin_original_token');
        dispatch('loginFromToken', token)
          .then(res => {
            return resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    loginFromToken({ commit }, token) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('clavedat');
        localStorage.removeItem('admin');
        localStorage.removeItem('customer_companies');
        localStorage.removeItem('billing_profiles');
        commit('logout');

        delete axios.defaults.headers.common['Authorization'];

        localStorage.setItem('token', token);
        // Add the following line:
        // console.log('loginFromToken');
        axios.defaults.headers.common['Authorization'] = token;
        axios.defaults.headers.common['Accept'] = 'application/json';
        axios.defaults.headers.common['Content-Type'] = 'application/json';

        axios
          .get(OG_CONFIG.API_URL + '/user/me')
          .then(res => {
            let user = res.data.data;
            let admin = false;
            localStorage.setItem('user', JSON.stringify(user));
            let clavedat = null;
            let customer_companies = [];

            // console.log(user);
            if (user.hasOwnProperty('roles') && user.roles && Array.isArray(user.roles)) {
              user.roles.forEach(element => {
                if (element.name == 'superadmin' || element.name == 'consultant') {
                  localStorage.setItem('admin', true);
                  admin = true;
                }
              });
            }
            if (
              user.hasOwnProperty('customer_profile') &&
              user.customer_profile &&
              user.customer_profile.hasOwnProperty('fiscal_data') &&
              user.customer_profile.fiscal_data &&
              Array.isArray(user.customer_profile.fiscal_data) &&
              user.customer_profile.fiscal_data[0] &&
              user.customer_profile.fiscal_data[0].hasOwnProperty('CLAVEDAT') &&
              user.customer_profile.fiscal_data[0].CLAVEDAT
            ) {
              clavedat = user.customer_profile.fiscal_data[0].CLAVEDAT;
              user.customer_profile.fiscal_data.forEach(fiscalData => {
                if (fiscalData.hasOwnProperty('CLAVEDAT') && fiscalData.CLAVEDAT) {
                  customer_companies.push(fiscalData.CLAVEDAT);
                }
              });
            }
            localStorage.setItem('clavedat', clavedat);
            localStorage.setItem('billing_profiles', JSON.stringify(user.openbilling_profiles));
            localStorage.setItem('customer_companies', JSON.stringify(customer_companies));
            commit('auth_success', {
              token: token,
              user: user,
              clavedat: clavedat,
              admin: admin,
              customer_companies: customer_companies,
            });
            resolve(res);
          })
          .catch(err => {
            commit('auth_error');
            // console.log({eeror: err});
            localStorage.removeItem('token');
            reject(err);
          });
      });
    },
    register({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        axios({
          url: 'http://localhost:3000/register',
          data: user,
          method: 'POST',
        })
          .then(resp => {
            const token = resp.data.token;
            const user = resp.data.user;
            localStorage.setItem('token', token);
            // Add the following line:
            axios.defaults.headers.common['Authorization'] = token;
            commit('auth_success', token, user);
            resolve(resp);
          })
          .catch(err => {
            commit('auth_error', err);
            localStorage.removeItem('token');
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise(resolve => {
        commit('logout');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('clavedat');
        localStorage.removeItem('admin');
        localStorage.removeItem('customer_companies');
        localStorage.removeItem('admin_original_token');
        localStorage.removeItem('billing_profiles');

        delete axios.defaults.headers.common['Authorization'];
        resolve();
      });
    },
  },
  getters: {
    isLoggedIn: state => !!state.token,
    userIsAdmin: state => !!state.admin,
    authStatus: state => state.status,
    userRoles: state => {
      return state.user && state.user.roles ? state.user.roles : [];
    },
    userCategoriesNames: state => {
      if (
        state.hasOwnProperty('user') &&
        state.user &&
        state.user.hasOwnProperty('consultant_profile') &&
        state.user.consultant_profile &&
        state.user.consultant_profile.hasOwnProperty('categories') &&
        state.user.consultant_profile.categories
      ) {
        const categories = [];
        state.user.consultant_profile.categories.forEach(element => {
          categories.push(element.name);
        });
        return categories;
      } else {
        return [];
      }
    },
    customerCategoriesNames: state => {
      if (
        state.hasOwnProperty('user') &&
        state.user &&
        state.user.hasOwnProperty('consultants') &&
        state.user.consultants
      ) {
        const categories = [];
        state.user.consultants.forEach(consultant => {
          if (
            consultant.hasOwnProperty('consultant_profile') &&
            consultant.consultant_profile.hasOwnProperty('categories')
          ) {
            consultant.consultant_profile.categories.forEach(category => {
              categories.push(category.name);
            });
          }
        });
        return categories;
      } else {
        return [];
      }
    },
    userRoleNames: (state, getters) => {
      const res = [];
      for (let i = 0; i < getters.userRoles.length; i++) {
        const roleObj = getters.userRoles[i];
        res.push(roleObj.name);
      }
      return res;
    },
    companies: state => {
      return get(state, 'user.customer_profile.fiscal_data', []);
    },
    currentCompany: (state, getters) => {
      let result = null;

      getters.companies.forEach(company => {
        if (
          company.hasOwnProperty('CLAVEDAT') &&
          Number(state.clavedat) === Number(company['CLAVEDAT'])
        ) {
          result = company;
        }
      });
      return result;
    },
    customerModules: (state, getters) => {
      let modules = null;
      if (getters.currentCompany) {
        modules = getters.currentCompany.customer_modules;
      }
      return modules;
    },
    openbillingProfiles: state => {
      return state.billing_profiles;
    },
    currentOpenbillingProfileId: (state, getters) => {
      return getters.currentOpenbillingProfile ? getters.currentOpenbillingProfile.id : null;
    },
    currentOpenbillingProfileAccountIban: (state, getters) => {
      return getters.currentOpenbillingProfile
        ? getters.currentOpenbillingProfile.account_iban
        : null;
    },
    currentOpenbillingProfileDefaultPaymentMethod: (state, getters) => {
      return getters.currentOpenbillingProfile
        ? getters.currentOpenbillingProfile.default_payment_method
        : null;
    },
    currentOpenbillingProfile: (state, getters) => {
      return state.billing_profiles.find(profile => profile['clavedat'] == state.clavedat);
    },
  },
});
